import React from "react";
import { Container, Typography, Box } from "@mui/material";
import SEOHead from "../../components/SEO/SEOHead";

export default function TermosUso() {
    return (
        <Container maxWidth="md" sx={{ py: 6 }}>
            <SEOHead
                title="Termos de Uso — HL Software"
                description="Leia os Termos de Uso da HL Software. Condições que regem o acesso e uso dos nossos sistemas e serviços digitais."
                canonical="https://www.hlsoftware.com.br/termos-de-uso"
                robots="noindex,follow"
            />
            <Typography variant="h4" gutterBottom color="primary">
                Termos de Uso
            </Typography>

            <Typography variant="body1" paragraph>
                Bem-vindo à HL Software. Ao utilizar nossos sistemas e serviços, você concorda com os seguintes termos.
                Por favor, leia com atenção.
            </Typography>

            <Box mt={4}>
                <Typography variant="h6" gutterBottom>
                    1. Aceitação dos Termos
                </Typography>
                <Typography variant="body2" paragraph>
                    Ao acessar ou usar nossos produtos, você concorda com estes Termos de Uso e com a Política de Privacidade.
                    Caso não concorde, não utilize os serviços.
                </Typography>
            </Box>

            <Box mt={3}>
                <Typography variant="h6" gutterBottom>
                    2. Uso do Serviço
                </Typography>
                <Typography variant="body2" paragraph>
                    Nossos sistemas devem ser utilizados de forma ética e legal. É proibido:
                    - praticar fraudes;
                    - compartilhar acessos com terceiros sem permissão;
                    - realizar engenharia reversa ou interferir no funcionamento da aplicação.
                </Typography>
            </Box>

            <Box mt={3}>
                <Typography variant="h6" gutterBottom>
                    3. Cadastro e Segurança
                </Typography>
                <Typography variant="body2" paragraph>
                    O usuário é responsável por manter seus dados de acesso seguros. A HL Software não se responsabiliza
                    por acessos não autorizados causados por negligência do próprio usuário.
                </Typography>
            </Box>

            <Box mt={3}>
                <Typography variant="h6" gutterBottom>
                    4. Modificações no Serviço
                </Typography>
                <Typography variant="body2" paragraph>
                    Podemos alterar, suspender ou descontinuar qualquer funcionalidade do sistema a qualquer momento,
                    com aviso prévio quando possível.
                </Typography>
            </Box>

            <Box mt={3}>
                <Typography variant="h6" gutterBottom>
                    5. Limitação de Responsabilidade
                </Typography>
                <Typography variant="body2" paragraph>
                    A HL Software não se responsabiliza por perdas indiretas, lucros cessantes ou danos causados por mau uso
                    dos nossos sistemas por parte do usuário.
                </Typography>
            </Box>

            <Box mt={3}>
                <Typography variant="h6" gutterBottom>
                    6. Contato
                </Typography>
                <Typography variant="body2" paragraph>
                    Dúvidas ou solicitações devem ser encaminhadas para <strong>contato@hlsoftware.com.br</strong>.
                </Typography>
            </Box>

            <Box mt={3}>
                <Typography variant="body2" color="text.secondary">
                    Última atualização: 24 de julho de 2025
                </Typography>
            </Box>
        </Container>
    );
}
